import React from 'react';
import SearchResult from '../../shared/SearchResults';
import { useUserStateContext } from '../../../context/user/user-contexts';

export default function CsmSearch() {
  const { user } = useUserStateContext();
  if (!user?.employeeId) return null;

  return (
    <SearchResult
      statuses={[
        'ACTIVE',
        'NEW',
        'WIP',
        'ESC',
        'AUI',
        'RESC',
        'RSLV',
        'CLSD',
        'REJ',
      ]}
      role={user.role}
      email={user.email}
      pageType="Search"
    />
  );
}
